module.exports = __webpack_public_path__ + "static/demco-min-8d29a13c2b03d4cee8431dc5646b6ced.png";